import { Menus } from '@/models'

export default {
    setMenus (state: { menu: Array<Menus> }, data: Array<Menus>) {
        state.menu = data
    }
}
